import type { ApiProxyClient } from '../../types';
import { getProductInventory } from './getProductInventory';
import { getProductInventoryPairs } from './getProductInventoryPairs';

export const inventoryApi: ApiProxyClient['inventory'] = {
    getProductInventory,
    getProductInventoryPairs,
};
